import { getService } from 'react-in-angularjs';

import { goTo } from '../../angularUtils';
import { setUserInfo } from '../setUserInfo/setUserInfo';
import { loggedInUserDataStore } from '../../../stores/loggedInUserDataStore';

/**
 * Logout user. Handles both corporate and regular user logout.
 *
 * @param redirectTo - Path to redirect after logout. Default is '/' (home/login page).
 *                    Pass null to stay on current page (page should be prepared to mobx re-render).
 *
 * For corporate users: Keeps corporate account info and redirects to PIN code page.
 * For regular users: Calls AuthService.signOut() which clears data and handles navigation.
 *
 * Navigation behavior (when not corporate):
 * - If redirectTo is provided: Immediately navigates to target page, then reloads with correct URL hash.
 *   This prevents showing invalid data during reload delay and avoids MobX re-render issues.
 * - If redirectTo is null: Reloads current page.
 */
export const logout = (redirectTo?: string | null) => {
  if (!loggedInUserDataStore.loggedInUser) {
    throw new Error('Logged in user not found, please login first');
  }

  const { corporateSignInStatuses, loggedInUser } = loggedInUserDataStore;
  const { corporateAccountInfo } = loggedInUser;
  const AuthService = getService('AuthService');

  if (corporateSignInStatuses.FINISHED_SING_IN && corporateAccountInfo) {
    setUserInfo({ corporateAccountInfo });
    goTo('/pin-code');
  } else {
    AuthService.signOut(redirectTo);
  }
};
